<template>
    <div class="report-dashboard">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="$route.name"></ContentHeader>
          <div class="row">
            <div class="col-sm-6"><h3>Total Nominations</h3></div>
            <div class="col-sm-6">
              <select id="totalNoms" ref="totalNoms" value="3 month ago" @change="loadTotalNomination">
                <option value="1m">Past 1 Months</option>
                <option value="3m">Past 3 Months</option>
                <option value="6m">Past 6 Months</option>
                <option value="12m">Past 12 Months</option>
                <option value="all">Overall</option>
              </select>
            </div>
            <pie-chart :legendData="totalNomsPieLegendData" :seriesData="totalNomsPieSeriesData" height="350px" :noClick=false></pie-chart>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-6"><h3>Pending Nominations</h3></div>
            <div class="col-sm-6"></div>
            <!-- <span v-if="pendingNomsPieLegendData.length"> -->
              <pie-chart :legendData="pendingNomsPieLegendData" :seriesData="pendingNomsPieSeriesData" :noClick=false></pie-chart>
            <!-- </span>
            <p v-else>No Pending Nomination</p> -->
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-6"><h3>Slow Responders</h3></div>
            <div class="col-sm-6"></div>
            <table class="table table-hover" v-if="responderTableData.length">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Days</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(email, series) in responderTableData">
                  <td>{{ email.email }}</td>
                  <td><router-link :to="{path: '/my-profile/review-manager/' + email.id }">{{ Object.keys(email.series)[0] + ' For ' + email.series[Object.keys(email.series)[0]] + ' days' }}</router-link></td>
                </tr>
              </tbody>
            </table>
            <p v-else>No Pending Nomination</p>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import PreContentHeader from '@/components/PreContentHeader'
import PieChart from '@/components/PieChart'
import $ from 'jquery'

export default {
  components: {
    PieChart,
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      responderyAxisData: [],
      responderxAxisData: [],
      responderTableData: [],
      termNames: [],
      respondersListVal: 10,
      barListVal: 10,
      barListDate: '3m',
      nomineeListVal: 10,
      nomineeListDate: '3m',
      pendingNomsPieLegendData: [],
      pendingNomsPieSeriesData: [],
      pendingNomsPieData: {},
      totalNomsPieLegendData: [],
      totalNomsPieSeriesData: [],
      totalNomsPieData: [],
      userDetails: null
    }
  },
  created () {
    this.contentReady = true
    this.userDetails = this.$store.getters.getProfileDetails
    console.log('UD in HRBP', this.userDetails)
    console.log('store in HRBP', this.$store)
  },
  mounted () {
    this.getTermNames()
    this.loadResponderBarChartNomination()
    this.loadPieChartNomination()
    this.loadTotalNomination()
  },
  methods: {
    loadResponderBarChartNomination: function () {
      console.log('responders')
      // this.respondersListVal = 10
      // this.responderyAxisData = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      // this.responderxAxisData = [ [30, 52, 200, 334, 390, 330, 220], [30, 52, 200, 334, 390, 330, 220], [0, 0, 0, 334, 0, 0, 0] ]
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/hrbp/slowresponders?hrbp=' + this.userDetails.email)
        .then(response => {
          //self.respondersListVal = Number(this.$refs.responderList.value)
          self.contentReady = true
          self.responderyAxisData = []
          self.responderxAxisData = []
          self.responderTableData = []
          let data = response.data
          // console.log('responder Data-> ', JSON.stringify(response.data))
          $.each (data, function (key, val) {
            $.each (val, function (k, v) {
              // console.log(k, v)
              // console.log(k, v.email)
              self.responderyAxisData.push(v.email)
              self.responderxAxisData.push(v.series)
              self.responderTableData.push({'email' : v.email, 'series' : v.series, 'id' : v.post_id})
            })
            // console.log(key, val.filter( x=> x.email ))
          })
          // self.responderyAxisData.push(response.data.map( function(x) { return x.email } ))
          // self.responderxAxisData.push(response.data.map( function (x) { return x.series } ))
          console.log('responderyAxisData-> ', self.responderyAxisData)
          console.log('responderxAxisData-> ', self.responderxAxisData)        
          console.log('responderTableData-> ', self.responderTableData)
          console.log('responderTableData len-> ', self.responderTableData.length)
        })
        .catch(e => {
          console.error(e)
          self.contentReady = true
        })
    },
    getTermNames: function() {
      var self = this
      // Parent 20 is for VE Awards and its active categories include HIgh5, on the Spot and Teams
      WordpressRestAPI.getViewContent('nomination_event_category?parent=20')
        .then(function (response) {
          self.termNames.push(response.data.map(function(x){return x.name}))
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    loadTotalNomination: function() {
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/hrbp/overall?hrbp=' + this.userDetails.email + '&date=' + this.$refs.totalNoms.value)
        .then(response => {
          self.totalNomsPieLegendData = []
          self.totalNomsPieSeriesData = []
          console.log('getNS-> ', response.data)
          self.totalNomsPieData = response.data
          $.each (self.totalNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.totalNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.totalNomsPieLegendData.push(camelCaseKey)
          })
          console.log('pieSeriesTM-> ', self.totalNomsPieSeriesData)
          console.log('pieLegendTM-> ', self.totalNomsPieLegendData)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadPieChartNomination: function() {
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/hrbp/pending?hrbp=' + this.userDetails.email)
        .then(response => {
          self.pendingNomsPieLegendData = []
          self.pendingNomsPieSeriesData = []
          console.log('getNS-> ', response.data)
          self.pendingNomsPieData = response.data
          $.each (self.pendingNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.pendingNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.pendingNomsPieLegendData.push(camelCaseKey)
          })
          console.log('pieSeriesCM-> ', self.pendingNomsPieSeriesData)
          console.log('pieLegendCM-> ', self.pendingNomsPieLegendData)
          console.log('pieLegendCM len-> ', self.pendingNomsPieLegendData.length)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/HrbpDashboard.vue